module.exports = {
  title: 'Spiral QRCode',
  author: 'Enzo Manuel Mangano',
  date: '2025-12-27',
  slug: 'notion-qrcode',
  tags: ['skia', 'reanimated'],
};
